import { getSettingValueWithoutAssignment } from "@faire/deprecated-retailer-visitor-shared/settings/__internal__/getSetting";
import { NEXTJS_RSC_PRODUCT_FIRST_CATEGORY_PAGE_ALLOWLIST } from "@faire/web-api--source/indigofair/settings/NEXTJS_RSC_PRODUCT_FIRST_CATEGORY_PAGE_ALLOWLIST";

export const getSettingNextJSRSCProductFirstCategoryPageAllowList = () =>
  getSettingValueWithoutAssignment(
    NEXTJS_RSC_PRODUCT_FIRST_CATEGORY_PAGE_ALLOWLIST,
    []
  );
